import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FormAuthState {
  loading: boolean;
  success: boolean;
  error: string | null;
  data: any;
  verificationStatus: 'idle' | 'success' | 'error';
}

const initialState: FormAuthState = {
  loading: false,
  success: false,
  error: null,
  data: null,
  verificationStatus: 'idle',
};

export const formAuthSlice = createSlice({
  name: 'formAuth',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },

    setData(state, action: PayloadAction<FormAuthState['data']>) {
      state.data = action.payload;
    },

    setSuccess(state, action: PayloadAction<boolean>) {
      state.success = action.payload;
    },

    setVerificationStatus(
      state,
      action: PayloadAction<FormAuthState['verificationStatus']>,
    ) {
      state.verificationStatus = action.payload;
    },

    clearFormAuthState(state) {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.data = null;
      state.verificationStatus = 'idle';
    },
  },
});

export const {
  setLoading,
  setError,
  setData,
  setSuccess,
  setVerificationStatus,
  clearFormAuthState,
} = formAuthSlice.actions;

const reducer = { formAuth: formAuthSlice.reducer };

export default reducer;
